/**
 * @author Harshitha.k
 * @description 
 */

import './singlehmi.css';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import moment from 'moment';
import { connect } from 'react-redux';
import queryString from 'query-string';
import cloneDeep from 'lodash.clonedeep';
import ReactEcharts from './Echarts/Echarts';
import { Modal, message, Button } from 'antd';
import localStorage from '../../utils/localStorage';
import StyledTable from "../../commons/styles/table";
import { IPAddress, REPORTS } from '../../commons/api';
import { getHmiAllParams, getReportNametoDownload } from './hmicalls';
import { AreaChartOutlined, DownloadOutlined } from '@ant-design/icons';

const columns = [
  {
    title: 'Parameter Name',
    dataIndex: 'Parameter',
    key: 'Parameter'
  },
  {
    title: 'Value',
    dataIndex: 'Value',
    key: 'Value'
  },
  {
    title: 'UOM',
    dataIndex: 'UOM',
    key: 'UOM'
  }
];

const Text = (props) => {
  // const [value, setValue] = useState(0);
  const [visible, setVisible] = useState(false);
  const [graphData, setGraphData] = useState([]);
  const [dataSource, setDataSource] = useState([]);
  // const [dataSourceStatus, setDataSourceStatus] = useState([]);
  const selectedParameters = useState([]);
  const [translationCache, setTranslationCache] = useState(props.translationCache || []);
  const [visibleGraph, setVisibleGraph] = useState(false);
  const [option, setOption] = useState({});
  const [reportName, setReportName] = useState('');
  const [dynamicColumns, setDynamicColumns] = useState([]);
  const [dynamicDatasource, setDynamicDatasource] = useState([]);
  const [dynamicVisible, setDynamicVisible] = useState(false);
  const [timeTicket, setTimeTicket] = useState(null);

  useEffect(() => {
    return () => {
      clearInterval(timeTicket);
    };
  }, [timeTicket]);

  useEffect(() => {
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }
  }, [props.translationCache]);

  const getParams = async () => {
    const { device, hmiName, hmiType, checkStatus } = props;
    const dataSource = await getHmiAllParams(device, hmiName, hmiType, checkStatus);
    setDataSource(dataSource);
    _getDataSource('HMI Modal', dataSource);
  };

  const _getDataSource = async (displayName, dataSource) => {
    const downloadExcelPayload = {
      Name: displayName,
      Consumption: 'HMI',
      ReportType: 'singleHierarchy',
      PortName: 'Rubus',
      SelectedDate: moment.utc().local().format('YYYY-MM-DD HH:mm') + '~' + moment.utc().local().format('YYYY-MM-DD HH:mm'),
      GeneratedDate: moment().format('YYYY-MM-DD HH:mm:ss')
    };
    const reportName = await getReportNametoDownload(columns, dataSource, downloadExcelPayload);
    setReportName(reportName && reportName.file ? reportName.file : '');
  };

  const onTrendClick = (parameters, deviceID) => {
    const data = queryString.stringify(
      { parameterlist: parameters, type: 'sld', device: deviceID },
      { arrayFormat: 'index' }
    );
    props.navigate(`/rubus/viewtrends?${data}`);
  };

  const _getGraphData = async (apiObject) => {
    const accessToken = localStorage.get('accessToken');
    const SiteId = localStorage.get('currentSite');
    let options = {};
    if (apiObject && apiObject.method === 'GET' && apiObject.url) {
      options = {
        method: apiObject.method,
        url: `${apiObject.url}`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`
        }
      };
    } else if (apiObject && apiObject.method === 'POST' && apiObject.payload && apiObject.url) {
      options = {
        method: apiObject.method,
        url: `${apiObject.url}`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`
        },
        data: JSON.stringify({
          ...apiObject.payload,
          GraphType: 'line',
          SiteId
        })
      };
    }
    try {
      const { data } = await axios(options);
      return Array.isArray(data) ? data : [];
    } catch {
      return [];
    }
  };

  const getOption = () => {
    return {
      backgroundColor: '#fff',
      title: {},
      legend: {
        icon: 'roundRect',
        textStyle: {
          color: '#000',
          fontSize: 15
        }
      },
      tooltip: {
        trigger: 'axis'
      },
      xAxis: {
        type: 'category',
        data: [],
        axisLine: {
          lineStyle: {
            color: '#000'
          }
        },
        axisTick: {
          lineStyle: {
            color: '#000'
          }
        },
        axisLabel: {
          color: '#000'
        }
      },
      yAxis: {
        type: 'value',
        axisLine: {
          lineStyle: {
            color: 'black'
          }
        },
        axisTick: {
          lineStyle: {
            color: 'black'
          }
        },
        axisLabel: {
          color: '#000'
        }
      },
      toolbox: {
        showTitle: false,
        orient: 'horizontal',
        itemSize: 25,
        feature: {
          saveAsImage: {
            title: 'download',
            backgroundColor: 'white',
            name: props.graphprops ? props.graphprops.title : 'name',
            iconStyle: {
              borderColor: '#8c8c8c',
              borderWidth: 2
            }
          }
        }
      },
      dataZoom: [
        {
          type: 'inside',
          start: 0,
          end: 100
        }
      ],
      series: {
        name: 'value',
        type: 'line',
        data: []
      }
    };
  };

  const getGraphDatasource = async (annotation) => {
    let option = cloneDeep(getOption());
    let xaxis = [];
    let series = [];
    let trendData = await _getGraphData(annotation.graphAPI);
    if (trendData.length > 0) {
      setGraphData(prevGraphData => [...prevGraphData, trendData[0]]);
    } else {
      message.warn('NO DATA');
    }
    graphData.forEach(data => {
      let dateUTC = '';
      if (data.DateTime) {
        dateUTC = moment.utc(data.DateTime, 'YYYY-MM-DD HH:mm:ss').local().format('YYYY-MM-DD HH:mm');
      }
      if (!xaxis.includes(data.DateTime)) {
        xaxis.push(dateUTC);
      }
      if (series.map(data => data.name).includes(data.Name)) {
        let index = series.map(data => data.name).indexOf(data.Name);
        series[index].data.push([dateUTC, data.Value]);
      } else {
        let obj = {
          type: 'line',
          name: data.Name,
          data: [data.Value],
          markPoint: {
            data: [
              { type: 'max', name: 'Max' },
              { type: 'min', name: 'Min' }
            ]
          }
        };
        series.push(obj);
      }
    });
    xaxis.sort((a, b) => new Date(a) - new Date(b));
    option.xAxis.data = xaxis;
    option.series = series;
    setOption(option);
  };

  const getDynamicDatasource = async (data, text) => {
    if (data && data.modalURL && data.modalURL.URL && data.modalURL.Method && data.modalURL.Payload) {
      const accessToken = localStorage.get('accessToken');
      const siteId = localStorage.get('currentSite');
      const deviceTypeObject = {
        method: `${data.modalURL.Method}`,
        url: `${data.modalURL.URL}?SiteId=${siteId}`,
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        ...(data.modalURL.Method === 'POST'
          ? {
            data: {
              ...data.modalURL.Payload,
              ...(data && data['dynamicKey'] ? { [data['dynamicKey']]: text } : {})
            }
          }
          : {})
      };
      try {
        const response = await axios(deviceTypeObject);
        const responseData = response.data;
        const dynamicColumns = responseData && responseData[0] ? Object.keys(responseData[0]).map(dataObject => ({
          title: dataObject,
          dataIndex: dataObject,
          key: dataObject
        })) : [];
        setDynamicColumns(dynamicColumns);
        setDynamicDatasource(responseData || []);
      } catch {
        return [];
      }
    }
  };

  const typeChecking = (payload) => {
    const { annotation } = props;
    if (typeof payload === 'string') {
      return payload;
    } else if (typeof payload === 'number' && !Number.isNaN(payload) && !Number.isInteger(payload)) {
      return payload.toFixed(annotation && (annotation.decimalLength || annotation.decimalLength === 0) ? annotation.decimalLength : 2);
    } else {
      return payload;
    }
  };

  const changeAlignment = (props) => {
    let { x, payload, alignment, annotation } = props;
    if (alignment === 'forward' && payload) {
      if (typeof payload === 'number' && !Number.isNaN(payload) && !Number.isInteger(payload)) {
        return (
          Number(x) -
          Number(
            payload
              .toFixed(
                annotation && (annotation.decimalLength || annotation.decimalLength === 0)
                  ? annotation.decimalLength
                  : 2
              )
              .toString().length * 6
          )
        );
      } else if (typeof payload === 'number') {
        return Number(x) - Number(payload.toString().length * 6);
      } else if (typeof payload === 'string') {
        return Number(x) - Number(payload.length * 6);
      } else {
        return x;
      }
    } else if (alignment === 'backward') {
      return x;
    } else {
      return x;
    }
  };

  const handleModalOpen = async (annotation, payload) => {
    if (timeTicket) {
      clearInterval(timeTicket);
    }
    if (annotation && annotation.modalType) {
      if (annotation.modalType === 'graph') {
        await getGraphDatasource(annotation);
        setVisibleGraph(true);
      } else if (annotation.modalType === 'dynamic') {
        await getDynamicDatasource(annotation, payload);
        setDynamicVisible(true);
      } else if (annotation.modalType === 'parameters') {
        await getParams();
        _getDataSource(props.displayName, dataSource);
        setVisible(true);
      }
    }

    const interval = setInterval(() => {
      if (annotation && annotation.modalType === 'graph') {
        getGraphDatasource(annotation);
      } else {
        getParams();
      }
    }, 60000);
    setTimeTicket(interval);
  };

  return (
    <React.Fragment>
      <text
        x={changeAlignment(props)}
        y={props.y}
        className={props.className}
        style={{ cursor: 'pointer' }}
        fontSize={props.fontSize}
        fontWeight={props.annotation.fontweight}
        fontFamily={props.fontFamily}
        fill={props.fill}
        onClick={() => handleModalOpen(props.annotation, props.payload)}
      >
        {typeChecking(props.payload)}
      </text>

      {props.displayName ? (
        <Modal
          visible={visible}
          closable
          title={
            props.displayName ? (
              <div>
                {props.displayName} ({props.device})
                <span>
                  {selectedParameters.length >= 1 && selectedParameters.length <= 5 ? (
                    <Button
                      type="primary"
                      icon={<AreaChartOutlined />}
                      onClick={() => onTrendClick(selectedParameters, props.device)}
                    />
                  ) : null}
                </span>
              </div>
            ) : (
              <div>
                Parameter List
                <span style={{ display: 'flex', flexDirection: 'row-reverse' }}>
                  {selectedParameters.length >= 1 && selectedParameters.length <= 5 ? (
                    <Button
                      type="primary"
                      icon={<AreaChartOutlined />}
                      onClick={() => onTrendClick(selectedParameters, props.device)}
                    />
                  ) : null}
                </span>
              </div>
            )
          }
          width={750}
          onOk={() => setVisible(false)}
          onCancel={() => setVisible(false)}
          footer={null}
        >
          <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
            {dataSource.length > 0 ? (
              <a href={`${IPAddress.LOCAL}${REPORTS.Reports}/${reportName}`}>
                <DownloadOutlined />
              </a>
            ) : null}
            {dataSource.map((item, index) => {
              if (index === 0) {
                const updatedTime = moment.utc(item.UpdatedTime, 'YYYY-MM-DD HH:mm:ss').tz(props.currentTimeZone).format('YYYY-MM-DD HH:mm:ss');
                return <div key={index}>Last Updated TimeStamp : {updatedTime}</div>;
              }
              return null;
            })}
          </div>
          <StyledTable size="small" columns={columns} dataSource={dataSource} />
        </Modal>
      ) : null}

      <Modal
        visible={dynamicVisible}
        closable
        title={props.displayName || 'Show Data'}
        width={750}
        onOk={() => setDynamicVisible(false)}
        onCancel={() => setDynamicVisible(false)}
        footer={null}
      >
        {dynamicColumns.length > 0 && dynamicDatasource.length > 0 ? (
          <StyledTable size="small"

          columns={dynamicColumns}
            dataSource={dynamicDatasource}
          />
        ) : (
          'No Data'
        )}
      </Modal>

      <Modal
        visible={visibleGraph}
        title={'Live Graph'}
        width={750}
        onOk={() => setVisibleGraph(false)}
        onCancel={() => setVisibleGraph(false)}
        footer={null}
      >
        <ReactEcharts
          option={option}
          notMerge={true}
          lazyUpdate={true}
          className="react_for_echarts"
        />
      </Modal>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache,
  currentTimeZone: state.LayoutReducer.currentTimeZone
});

export default connect(mapStateToProps)(Text);